export default __webpack_public_path__ + "static/media/selected.87c44028.svg";